import React, { useState } from "react";
import { API_BASE } from "../apiConfig";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import "./ScreenLockModal.css";

const ScreenLockModal = ({ onUnlock }) => {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);

  const handleUnlock = async (e) => {
    e.preventDefault();
    setError("");
    setIsVerifying(true);

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        setError("Session expired. Please login again.");
        setIsVerifying(false);
        return;
      }

      const response = await fetch(`${API_BASE}/api/auth/verify-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ password }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        onUnlock();
      } else {
        setError(data.message || "Incorrect password.");
      }
    } catch (err) {
      console.error("Password verification error:", err);
      setError("Failed to verify password. Please try again.");
    } finally {
      setIsVerifying(false);
    }
  };

  return (
    <div className="screen-lock-overlay">
      <div className="screen-lock-modal">
        <FontAwesomeIcon icon={faLock} className="lock-icon" />
        <h3>Screen Locked</h3>
        <p>Enter your password to unlock the screen</p>
        <form onSubmit={handleUnlock}>
          <div className="password-input-container">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <FontAwesomeIcon
              icon={showPassword ? faEyeSlash : faEye}
              className="toggle-password-icon"
              onClick={() => setShowPassword(!showPassword)}
            />
          </div>
          {error && <p className="error-message">{error}</p>}
          <button
            type="submit"
            className="unlock-button"
            disabled={!password || isVerifying}
          >
            {isVerifying ? "VERIFYING..." : "UNLOCK"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ScreenLockModal;
